<template>
  <v-alert
      :value="subscriptionExtensionAttempt"
      :type="type"
  >
    {{ messageKey|trans }} <a v-if="displayEmail" href="mailto:kontakt@dietico.pl">kontakt@dietico.pl</a>
  </v-alert>
</template>

<script>

const TEST_SUBSCRIPTION_EXTENSION_SUCCESS_STATUS_ID = 1;
const TEST_SUBSCRIPTION_EXTENSION_FAILURE_ALREADY_EXTENDED_STATUS_ID = 2;
const TEST_SUBSCRIPTION_EXTENSION_FAILURE_OTHER_SUBSCRIPTION_ACTIVE_STATUS_ID = 3;
const TEST_SUBSCRIPTION_EXTENSION_FAILURE_OTHER_REASON_STATUS_ID = 4;

export default {
  name: "TestSubscriptionExtended",
  data: function () {
    return {
      subscriptionExtensionAttempt: false,
      type: null,
      messageKey: '',
      displayEmail: false,
      statusesWithLink: [
        TEST_SUBSCRIPTION_EXTENSION_FAILURE_ALREADY_EXTENDED_STATUS_ID,
        TEST_SUBSCRIPTION_EXTENSION_FAILURE_OTHER_REASON_STATUS_ID
      ]
    };
  },
  mounted() {
    const subscriptionExtended = new URLSearchParams(window.location.search);
    this.subscriptionExtensionAttempt = subscriptionExtended.has('status');
    if (this.subscriptionExtensionAttempt === true) {
      const subscriptionExtensionStatus = Number.parseInt(subscriptionExtended.get('status'));
      this.makeDataFromStatus(subscriptionExtensionStatus);
      this.displayEmail = this.shouldDisplayEmailLink(subscriptionExtensionStatus);
    }
  },
  methods: {
    makeDataFromStatus: function (statusId) {
      switch (statusId) {
        case TEST_SUBSCRIPTION_EXTENSION_SUCCESS_STATUS_ID:
          this.type = 'success';
          this.messageKey = 'app.test_subscription_extension.success';
          break;
        case TEST_SUBSCRIPTION_EXTENSION_FAILURE_ALREADY_EXTENDED_STATUS_ID:
          this.type = 'error';
          this.messageKey = 'app.test_subscription_extension.failure_more_than_one_attempt';
          break;
        case TEST_SUBSCRIPTION_EXTENSION_FAILURE_OTHER_SUBSCRIPTION_ACTIVE_STATUS_ID:
          this.type = 'error';
          this.messageKey = 'app.test_subscription_extension.failure_active';
          break;
        default:
          this.type = 'error';
          this.messageKey = 'app.test_subscription_extension.failure_other';
      }
    },
    shouldDisplayEmailLink: function (statusId) {
      return this.statusesWithLink.includes(statusId);
    }
  }
}
</script>